// services/faqService.js pour l'application cliente
import axios from 'axios';

// URL de base de l'API - assurez-vous qu'elle est configurée correctement
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_URL = 'https://resolvebo.innovationcode.pro/api';


export const faqService = {
    getAllCategories: async (includeItems = false) => {
        try {
            const response = await axios.get(`${API_URL}/faqs/categories?includeItems=${includeItems}`);
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Erreur lors de la récupération des catégories FAQ', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Erreur lors de la récupération des FAQ'
            };
        }
    },

    getCategoryById: async (id, includeItems = true) => {
        try {
            const response = await axios.get(`${API_URL}/faqs/categories/${id}?includeItems=${includeItems}`);
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Erreur lors de la récupération de la catégorie FAQ', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Erreur lors de la récupération de la catégorie'
            };
        }
    },

    getItemsByCategory: async (categoryId) => {
        try {
            const response = await axios.get(`${API_URL}/faqs/categories/${categoryId}/items`);
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Erreur lors de la récupération des questions FAQ', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Erreur lors de la récupération des questions'
            };
        }
    }
};